import { useNavigate } from 'react-router-dom';
import { LogIn, LogOut, Settings } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

// HeaderAuthButtons — extraído de Header.jsx en P3.1 refactor (feb-2026).
// Contiene: botón Settings (si está logueado) + Login o Logout.
// Mantiene JSX y clases idénticos al original.
//
// 🟪 P25.6 (feb-2026) — Nuevo prop `only` para renderizar SOLO Settings
// o SOLO Login/Logout. Necesario para colocar Settings dentro del scroll
// horizontal del header en mobile/tablet y dejar Logout ANCLADO fuera
// del scroll a la derecha del todo. Comportamiento por defecto sin
// pasar `only` = ambos (retrocompatible).
const HeaderAuthButtons = ({ isLoggedIn, onLogout, onOpenSettings, only }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const showSettings = only !== 'auth';
  const showAuth = only !== 'settings';

  return (
    <>
      {/* Settings Button */}
      {showSettings && isLoggedIn && (
        <button
          onClick={onOpenSettings}
          className="p-1 sm:p-2 rounded-lg bg-zinc-800/50 hover:bg-zinc-700/50 light:bg-zinc-100 light:hover:bg-zinc-200 border border-zinc-700/50 light:border-zinc-300 transition-colors duration-200 text-zinc-400 hover:text-white light:text-zinc-600 light:hover:text-zinc-900"
          title={t('settings.title') || 'Configuración'}
          data-testid="settings-btn"
        >
          <Settings className="w-3.5 h-3.5 sm:w-5 sm:h-5" strokeWidth={1.5} />
        </button>
      )}

      {showAuth && (isLoggedIn ? (
        <button
          data-testid="logout-btn"
          onClick={onLogout}
          className="flex items-center gap-1 sm:gap-2 px-1.5 sm:px-4 py-1 sm:py-2 rounded-lg bg-zinc-800/50 hover:bg-zinc-700/50 light:bg-zinc-100 light:hover:bg-zinc-200 border border-zinc-700/50 light:border-zinc-300 transition-colors duration-200 text-zinc-400 hover:text-red-400 light:text-zinc-600 light:hover:text-red-500"
          title={t('dashboard.logout')}
        >
          <LogOut className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={1.5} />
          <span className="text-xs sm:text-sm hidden sm:inline">{t('dashboard.logout')}</span>
        </button>
      ) : (
        <button
          data-testid="login-btn"
          onClick={() => navigate('/login')}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 border border-indigo-500/50 transition-colors duration-200 text-white"
          title={t('auth.login')}
        >
          <LogIn className="w-4 h-4" strokeWidth={1.5} />
          <span className="text-sm hidden sm:inline">{t('auth.login')}</span>
        </button>
      ))}
    </>
  );
};

export default HeaderAuthButtons;
